<template>
  <div class="reasons-container">
    <div class="reasons-title-wrapper">
      <div class="reasons-title">
        <p>専門業者がおすすめな理由</p>
      </div>
    </div>

    <ul class="reasons-list">
      <li v-for="(reason, index) in reasons" :key="index" class="reason-item">
        <div class="reason-number">
          {{ index + 1 }}
        </div>
        <div class="reason-content">
          <p class="reason-text-title">{{ reason.title }}</p>
          <img v-if="reason.img" :src="reason.img" alt="">
          <p class="reason-text-description" v-html="reason.description"></p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref } from 'vue';
// ローカル画像をインポートする
import reasonImg1 from '../../assets/recommend-reason/1.png';
import reasonImg2 from '../../assets/recommend-reason/2.png';
import reasonImg3 from '../../assets/recommend-reason/3.png';

const reasons = ref([
  {
    title: 'メーカー直入れだから圧倒的に安い！',
    img: reasonImg1,
    // ここを修正: 閉じタグを </span> に変更
    description: '専門業者は給湯器メーカーや卸業者と直接取引をしているため、<span style="font-weight: bold; color: #e65248;">中間マージンがかかりません</span>。<br><br>その分、本体価格を家電量販店やガス会社より<span style="font-weight: bold; color: #e65248;">大幅に安く提供</span>できます。'
  },
  {
    title: '最短当日可能！対応スピードが早い！',
    img: reasonImg2,
    description: '専門業者は自社で在庫を確保していることが多いため、<span style="font-weight: bold; color: #e65248;">最短で当日の設置も可能</span>です。<br><br>急な故障が起きても、<span style="font-weight: bold; color: #e65248;">その日のうちにお湯が使えるようになり</span>、「お湯が使えない期間」を最小限に抑えられるのは大きなメリットです。'
  },
  {
    title: '保証が充実している！',
    img: reasonImg3,
    description: '家電量販店やガス会社では長期保証が有料になることも多いですが、<span style="font-weight: bold; color: #e65248;">専門業者なら無料で10年保証が付く</span>ケースもあります。<br><br>さらに<span style="font-weight: bold; color: #e65248;">工事保証まで充実</span>しているため、万が一のトラブル時も安心して任せられます。'
  },
]);
</script>

<style scoped>
.reasons-container {
  border-radius: 0.5rem;
  padding: 1rem;
  padding-top: 3rem;
  background-color: #ffffff;
  position: relative;
  margin-top: 40px;
  margin-bottom: 30px;
  border: 1px solid #e6e3e3;
}

.reasons-title-wrapper {
  position: absolute;
  top: -2.0rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  padding: 0.8rem 1rem;
  background-color: #fcd34d;
  white-space: nowrap;
  border-radius: 10px;
}

.reasons-title {
  font-weight: bold;
  -webkit-text-stroke: 2px black;
  text-stroke: 2px black;
  paint-order: stroke;
  color: #fff;
}

.reasons-title p {
  font-size: 1.2rem;
  margin: 0;
}

.reasons-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.reason-item {
  display: flex;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #d1d5db;
}

.reason-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.reason-number {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  background-color: #fcd34d;
  color: #374151;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.125rem;
  margin-right: 1.5rem;
  border-radius: 50px;
}

.reason-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  text-align: justify;
}

.reason-text-title {
  font-size: 1.2rem;
  margin: 0;
  font-weight: bold;
}

.reason-text-image,
.reason-text-description {
  margin: 0;
  font-size: 0.85rem;
  color: #1f2937;
  text-align: justify;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 90%;
}

.reason-content img {
  width: 95%;
  border-radius: 7px;
  margin-top: 10px;
}

.bold-red {
  font-weight: bold;
  color: red;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
  .reasons-container {
    width: 80%;
  }

  .reasons-title p {
    font-size: 1.4rem;
  }

  .reasons-title-wrapper {
    top: -2rem;
  }

  .reason-number {
    width: 2rem;
    height: 2rem;
    font-size: 1.2rem;
  }

  .reason-text-title {
    font-size: 1.2rem;
    letter-spacing: -0.8px;
  }

  .reason-text-description {
    font-size: 1rem;
  }
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 480px) {
  .reasons-title p {
    font-size: 1.2rem;
  }

  .reasons-title-wrapper {
    top: -2rem;
  }

  .reason-number {
    margin: 0;
    margin-right: 10px;
  }

  .reason-number {
    width: 2rem;
    height: 2rem;
    font-size: 1.2rem;
  }

  .reason-text-title {
    font-size: 1.1rem;
    letter-spacing: -0.8px;
  }

  .reason-text-description {
    font-size: 0.9rem;
  }
}
</style>